import algoliasearch from "algoliasearch";

const client = algoliasearch(
  "NSNZ9MCQCG",
  "9e16c1853f8a4c2b0569ae53d00c3010"
);

export const saveItemIndex = async (indexName, objectID, data) => {
  const index = client.initIndex(indexName);
  let obj = await index.saveObject({
    objectID,
    ...data,
  });
  return obj;
};

export const updateItemIndex = async (indexName, objectID, data) => {
  const index = client.initIndex(indexName);
  let obj = await index.partialUpdateObject({
    objectID,
    ...data,
  });
  return obj;
};

export const deleteItemIndex = async (indexName, objectID) => {
  const index = client.initIndex(indexName);
  let obj = await index.deleteObject(objectID);
  return obj;
};

export const algoliaIndexSearch = async (
  indexName: string,
  query: string
) => {
  const index = client.initIndex(indexName);
  let list = await index.search(query, {
    hitsPerPage: 200,
  });

  return list.hits;
};

export const algoliallSearch = async (indexName: string) => {
  const index = client.initIndex(indexName);
  let hits = [];
  await index.browseObjects({
    batch: (batch) => {
      hits = hits.concat(batch);
    },
  });
  return hits;
};
